import { TOURHERO_AI_ASSISTANT_NAME } from '../models'

export const PLAN_A_TRIP_CHAT_SOURCE = 'product_plan_a_trip_chat'
export const PLAN_A_TRIP_SOURCE = 'product_plan_a_trip'
export const REDIRECT_AI_CUSTOMISATION_ACTION = 'redirect'
export const REDIRECT_PLAN_A_TRIP_CHAT_ACTION = 'redirect-plan-a-trip'

export const ITINERARY_AI_CUSTOMISATION_REDIRECT_MESSAGE = {
  id: 'ai-redirect-message',
  messageType: 'prompted',
  content:
    "Hi, I'm Maya — your travel expert!\n\nI'll help you fine-tune your itinerary, then pass it to our local guides who operate the trip to finalize.\n\nTo continue planning, let's go to your draft itinerary so that you can see any changes we make to your trip plan instantly.",
  senderId: 'ai-assistant',
  senderName: TOURHERO_AI_ASSISTANT_NAME,
  displayName: true,
  options: [
    {
      text: 'Go to draft itinerary',
      action: REDIRECT_AI_CUSTOMISATION_ACTION,
    },
  ],
}

export const PLAN_A_TRIP_CHAT_REDIRECT_MESSAGE = {
  id: 'plan-a-trip-redirect-message',
  messageType: 'prompted',
  content:
    "Hi, I'm Maya — your travel expert!\n\nI'll help you fine-tune your itinerary, then pass it to our local guides who operate the trip to finalize.\n\nTo continue planning, let's go to your draft itinerary so that you can see any changes we make to your trip plan instantly.",
  senderId: null,
  senderName: TOURHERO_AI_ASSISTANT_NAME,
  displayName: true,
  options: [
    {
      text: 'Continue planning this trip',
      action: REDIRECT_PLAN_A_TRIP_CHAT_ACTION,
    },
  ],
}
